import {Component, Object3D, RetainEmitter} from '@wonderlandengine/api';
import {WLUtils} from '../utils/WLUtils.js';
import {CustomLogTag} from '../classes/Constants.js';

export class FruitPrefabs extends Component {
    static TypeName = 'fruit-prefabs';

    // Singleton
    private static _instance: FruitPrefabs;
    static get instance(): FruitPrefabs {
        return FruitPrefabs._instance;
    }

    fruitPrefabs!: Object3D;
    onPrefabsLoaded = new RetainEmitter<[Object3D]>();

    private _isLoaded = false;
    get isLoaded() {
        return this._isLoaded;
    }

    init(): void {
        FruitPrefabs._instance = this;
    }

    async start() {
        const s = await this.engine.loadPrefab('Fruit.bin');
        const r = this.engine.scene.instantiate(s);

        this.fruitPrefabs = r.root;
        this.fruitPrefabs.parent = this.object;

        WLUtils.setActive(this.fruitPrefabs, false);
        this._isLoaded = true;
        setTimeout(() => this.onPrefabsLoaded.notify(this.fruitPrefabs), 0);
    }
    /**
     * Spawns a fruit with the given name
     * @param name Name of the fruit to spawn
     * @param parent Optional parent object of the fruit
     * @param startActive Optional boolean to set the active state of the fruit; default is true
     * @returns The spawned fruit object or null if spawn failed
     */
    spawn(name: string, parent: Object3D | null = null, startActive = true) {
        if (!this.fruitPrefabs) {
            this.engine.log.warn(
                CustomLogTag.Game,
                `Spawning Fruit Failed. Fruit Prefabs not loaded`
            );
            return null;
        }

        const fruit = this.fruitPrefabs.findByName(name)[0];

        if (!fruit) {
            this.engine.log.warn(
                CustomLogTag.Game,
                `Spawning Fruit Failed. Fruit with name ${name} not found`
            );
            return null;
        }

        const clonedFruit = fruit.clone(parent);

        //this.engine.log.info(CustomLogTag.Game, `Spawned Fruit ${name}`);
        if (startActive) {
            WLUtils.setActive(clonedFruit, true);
        }

        clonedFruit.resetPositionRotation();
        return clonedFruit;
    }
}
